module.exports = __webpack_public_path__ + "img/syukyaku-gyoumu-back001.97249ee2.jpg";